<template>
  <v-app id="inspire" class="grey lighten-3">
   <UserNavbar/>
   <v-main>
     <v-flex>
        <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs10 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs2 >
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.86em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <UserHeader/>
        <v-layout row>
          <v-flex xs12 pa-5>
            <v-card
              tile
              class="mx-auto"
            >
            <v-flex>
            <v-progress-linear
              id="progress"
              color="#009933"
              height="4.5"
              indeterminate
              :active="loading"
            />
            </v-flex>
              <v-list>
                <v-list-item-content>
                  <v-list-item-subtitle :v-model="name" class="pl-4 pb-4"  style=" font-size: 0.96em;">
                    <span>{{name}}</span>
                    <v-icon
                      @click="fullscreen"
                      style="float: right;"
                      color="green"
                      class=" pr-7" >
                        mdi-presentation
                    </v-icon>
                    <v-icon
                      v-if="!isPlaying && isLoaded"
                      @click="startPlaying()"
                      style="float: right;"
                      color="green"
                      class=" pr-4" >
                        mdi-motion-play
                    </v-icon>
                    <v-icon
                      v-if="isPlaying && isLoaded"
                      @click="stopSlideshow()"
                      style="float: right;"
                      color="green"
                      class=" pr-4" >
                        mdi-motion-pause
                    </v-icon>

                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="ml-6 mr-6"  >
                  <div v-if="!mobileCheck" id="embedContainer" style="height:90vh; border: 0px;" ></div>
                  <div v-if="mobileCheck" id="embedContainer" style=" height: 40vh; border: 0px;" ></div>
                  <div style="text-align: center;" class="mt-2">
                    <v-btn
                      color="#339966"
                      class="text-none pa-4 mt-2 mb-4 ml-2"
                      dark
                      tile
                      style="font-size: 0.84em;"
                      @click="fullscreen">
                      Enter fullscreen mode
                    </v-btn>
                </div>
                </v-list-item-content>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
     </v-flex>
   </v-main>
  </v-app>
</template>

<script>
import UserNavbar from '@/components/UserNavbar'
import UserHeader from '@/components/UserHeader'
import * as pbi from 'powerbi-client'
import { isMobile } from 'mobile-device-detect'
export default {
  data: () => {
    return {
      currentPage: 0,
      reports: [],
      isLoaded: false,
      isPlaying: false,
      slideshow: null,
      currentReportIndex: 0,
      report: null,
      fullscreenPattern: [],
      feedback: '',
      rating: 0,
      items: [],
      userIds: null,
      message: '',
      feedbackDialog: false,
      ratingDialog: false,
      recommendationDialog: false,
      reportId: '',
      datasetId: '',
      mobileCheck: isMobile,
      loading: true,
      snackbar: false,
      ratingSnackbar: false,
      feedbackLoader: false,
      hasFeedback: false,
      name: '',
      crumbItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '#'
        }
      ],
      snackbarError: { icon: 'mdi-server-network-off', label: 'A system error occurred, please try again.' }
    }
  },
  components: {
    UserNavbar,
    UserHeader
  },
  methods: {
    // loads a powerbi dashboard
    async loadReport (reportName, reportId, datasetId, embedUrl, token) {
      this.stopSlideshow()
      const passphrase = process.env.VUE_APP_PASSPHRASE

      this.name = reportName

      // Read embed type from radio
      var models = pbi.models
      // We give All permissions to demonstrate switching between View and Edit mode and saving report.
      var permissions = models.Permissions.All
      // Embed configuration used to describe the what and how to embed.
      var config = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: token,
        embedUrl: embedUrl,
        id: reportId,
        permissions: permissions,
        settings: {
          panes: {
            filters: {
              visible: true
            },
            pageNavigation: {
              visible: true
            }
          }
        }
      }
      let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)

      if (powerbi !== null && powerbi !== undefined && document.getElementById('embedContainer')) {
        powerbi.reset(document.getElementById('embedContainer'))
        // Get a reference to the embedded report HTML element
        var embedContainer = document.getElementById('embedContainer')
        // this.powerbi.reset(embedContainer)
        // if (embedContainer.firstChild !== null) {
        // }

        // Embed the report and display it within the div container.
        this.report = powerbi.embed(embedContainer, config)
        // Report.off removes a given event handler if it exists.
        this.report.off('loaded')
        this.report.on('loaded', () => {
          this.isLoaded = true
          parent.document.getElementById('progress').style.visibility = 'hidden'
          this.fullscreenExit()
          this.startPlaying()
        })
        // Report.off removes a given event handler if it exists.
        this.report.off('rendered')
        this.report.on('rendered', function () {
        })
        this.report.on('error', (event) => {
          parent.document.getElementById('progress').style.visibility = 'hidden'
          const message = event.detail.message
          if (message === 'TokenExpired') {
            // get the refresh embed token
            window.axios.post('/viewership/getEmbedToken', { reportId: reportId, datasetId: datasetId })
              .then(async (response) => {
                const token = response.data.token
                const encryptedToken = this.$CryptoJS.AES.encrypt(token, passphrase).toString()
                localStorage.setItem('tken', encryptedToken)
                window.location.reload()
              })
              // eslint-disable-next-line handle-callback-err
              .catch(() => {
              })
          }
        })
        this.report.off('saved')
        // this.report.on('saved', function () {
        //   if (event.detail.saveAs) {
        //   }
        // })
        this.report.off('visualClicked')
        // this.report.on('visualClicked', (event) => {
        //   // console.log('clicked')
        //   // this.visualClick()
        // })
        this.report.off('pageChanged')
        // this.report.on('pageChanged', (event) => {
        //   // console.log('pageChanged', event)
        // })
      }
    },
    // listens when the visual is out of fullscreen
    fullscreenExit () {
      document.addEventListener('fullscreenchange', () => {
        // The key is to check document.fullscreenElement.
        if (document.fullscreenElement === null) {
          // This is the correct way to detect an exit from fullscreen.
          // console.log('Exited fullscreen. The iframe is no longer visible.')
          // Add your custom logic here, like clearing a pulsing animation.
          // if (this.slideshow !== null) {
          //   this.stopSlideshow()
          // }
        }
      })
    },
    // start the slideshow
    async startSlideshow () {
      try {
        const reportData = this.reports[this.currentReportIndex]

        const reportName = reportData.name
        const reportId = reportData.report_id
        const datasetId = reportData.dataset_id
        const embedUrl = reportData.embed_url
        const embedTokenData = await window.axios.post('/viewership/getEmbedToken', { reportId: reportId, datasetId: datasetId })
        const token = embedTokenData.data.token

        this.loadReport(reportName, reportId, datasetId, embedUrl, token)
      } catch (error) {
        console.error(error)
      }
    },
    // start playing
    startPlaying () {
      try {
        // this.fullscreen()
        this.isPlaying = true
        this.currentPage = 0

        // starts the interval
        this.slideshow = setInterval(async () => {
          try {
            if (this.report !== null) {
              // get the pages of a report
              const allPages = await this.report.getPages()
              const visiblePages = allPages.filter(page => page.visibility === 0)
              const size = visiblePages.length - 1

              // sets the current page
              if (size > 0) {
                this.currentPage += 1
              }

              // gets the all the visible pages of a report
              const page = visiblePages[this.currentPage]
              const pageName = page.name

              this.report.setPage(pageName)

              // detects the end of the pages of a dashboard
              if (this.currentPage === size) {
                // get the size of the reports
                const reportsSize = this.reports.length

                // set the current page to the initial page
                this.currentPage = 0

                // load the next report
                if (this.currentReportIndex === (reportsSize - 1)) {
                  this.currentReportIndex = 0
                } else {
                  this.currentReportIndex += 1
                }

                // load the report report
                const reportData = this.reports[this.currentReportIndex]

                const reportName = reportData.name
                const reportId = reportData.report_id
                const datasetId = reportData.dataset_id
                const embedUrl = reportData.embed_url
                const embedTokenData = await window.axios.post('/viewership/getEmbedToken', { reportId: reportId, datasetId: datasetId })
                const token = embedTokenData.data.token

                this.loadReport(reportName, reportId, datasetId, embedUrl, token)
              }
            }
          } catch (err) {
            console.log(err)
          }

        }, 1000 * 30)
      } catch (error) {
        console.error(error)
      }
    },
    stopSlideshow () {
      this.isPlaying = false
      clearInterval(this.slideshow)
    },
    async changePage (change) {
      try {
        // var currentpage = 0
        // move to the next page
        if (this.report !== null) {
          const allPages = await this.report.getPages()
          const visiblePages = allPages.filter(page => page.visibility === 0)
          const size = visiblePages.length

          if (change === '+') {
            if ((this.currentPage + 1) < size) {
              this.currentPage += 1
              // gets the all the visible pages of a report
              const page = visiblePages[this.currentPage]
              const pageName = page.name

              this.report.setPage(pageName)
            }
          } else {
            if (this.currentPage > 0) {
              this.currentPage -= 1
              // gets the all the visible pages of a report
              const page = visiblePages[this.currentPage]
              const pageName = page.name

              this.report.setPage(pageName)
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    fullscreen () {
      // check if fullscreen mode is available
      if (document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled) {
        // which element will be fullscreen
        var iframe = document.querySelector('#embedContainer')
        // Do fullscreen
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen()
        } else if (iframe.webkitRequestFullscreen) {
          iframe.webkitRequestFullscreen()
        } else if (iframe.mozRequestFullScreen) {
          iframe.mozRequestFullScreen()
        } else if (iframe.msRequestFullscreen) {
          iframe.msRequestFullscreen()
        }
      } else {
        document.querySelector('.error').innerHTML = 'Your browser is not supported'
      }
    },
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  },
  unmounted () {
    if (this.slideshow !== null) {
      clearInterval(this.slideshow)
    }
  },
  onDeactivated () {
    if (this.slideshow !== null) {
      clearInterval(this.slideshow)
    }
  },
  mounted: [
    // function () {
    //   window.axios.get('/user/findAll')
    //     .then((response) => {
    //       this.items = response.data
    //     })
    //     .catch(() => {})
    // },
    // loads random reports
    function () {
      const passphrase = process.env.VUE_APP_PASSPHRASE
      const accessToken = localStorage.getItem('token')
      const decryptedAccessToken = this.CryptoJS.AES.decrypt(accessToken, passphrase).toString(this.CryptoJS.enc.Utf8)
      window.axios.defaults.headers.common.Authorization = `Bearer ${decryptedAccessToken}`

      var userTypeId = localStorage.getItem('utp')
      var userId = localStorage.getItem('kwkk')
      window.axios.post('/report/findByUserGroupRandom', { userTypeId: userTypeId, userId: userId })
        .then((response) => {
          var data = response.data
          data = data.filter(data => data.type === 'Power Bi')
          this.reports = data
          // start the slideshow
          this.startSlideshow()
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
    },
    // handles key clicks
    function () {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          this.changePage('+')
        } else if (event.key === 'ArrowLeft') {
          this.changePage('-')
        }
        // listen for the following keys to go into fullscreen mode
        // Control, Shift & F
        // this.fullscreen()
        // and only add the key if its not available
        const keyCheck = this.fullscreenPattern.some((data) => {
          return data === event.key
        })
        var patternSize = this.fullscreenPattern.length

        if (patternSize <= 3 && !keyCheck && (event.key === 'Control' || event.key === 'Shift' || event.key === 'F')) {
          this.fullscreenPattern.push(event.key)
          // check if the Ctrl, Shift & F pattern was pressed
          // console.log('added ---->', event.key)
          patternSize = this.fullscreenPattern.length
          if (patternSize === 3 && this.fullscreenPattern[0] === 'Control' && this.fullscreenPattern[1] === 'Shift' && this.fullscreenPattern[2] === 'F') {
            this.fullscreen()
          }
        }
        // console.log(this.fullscreenPattern)
      })

      document.addEventListener('keyup', (event) => {
        // listen for the following keys to go into fullscreen mode
        // Control, Shift & F
        // this.fullscreen()
        if (event.key === 'Control' || event.key === 'Shift' || event.key === 'F') {
          // remove the key from the pattern
          const size = this.fullscreenPattern.length

          for (let i = 0; i < size; i++) {
            const key = this.fullscreenPattern[i]

            // if it there remove it
            if (event.key === key) {
              this.fullscreenPattern.splice(i, 1)
              break
            }
          }
        }
      })
    }
  ]
}
</script>

<style scoped>

.v-text-field >>> input {
  font-size: 0.86em;
}
.v-text-field >>> label {
  font-size: 0.86em;
}

#crumbs{
  align-content: right;
  justify-content: right;
}
#powerBiFrame{
  padding-left: 2%;
  padding-right: 2%;
  padding-top: 2%;
}
</style>
